let tooptipClass = "[class$='__info-popup'], [class$='__item-payment-popup'], [class$='__item-info-popup']";
let tooptipBtnClass = "[class$='__info-button'], [class$='__item-payment-button'], [class$='__item-info-button']";

function openTooltip(tooltip, e)
{
	tooltip.fadeIn();
	$(document).bind('click', testCloseTooltip);

}
function testCloseTooltip(e)
{
	let el = $(e.target);
    console.log(el);
	if (!el.closest(tooptipClass).length && !el.closest(tooptipBtnClass).length)
        closeTooltip();
}
function closeTooltip()
{
	console.log(this);
	$(tooptipClass).fadeOut();
	$(document).unbind('click', testCloseTooltip);
}


$('.price-block__info-button').click(function(e){
	let _t = $(this).next();
	closeTooltip();
	openTooltip(_t, e);
});
$('.price-block__info-close').click(function(){
	closeTooltip();
});

$('.implants-item__info-button').click(function(e){
	let _t = $(this).next();
	closeTooltip();
	openTooltip(_t, e);
});
$('.implants-item__info-close').click(function(){
	closeTooltip();
});

//��� �������� �����������
$('.impl-price__item-payment-button').click(function(e){
	let _t = $(this).next();
	closeTooltip();
	openTooltip(_t, e);
});
$('.impl-price__item-payment-close').click(function(){
	closeTooltip();
});

$('.impl-price__item-info-button').click(function(e){
	let _t = $(this).next();
	closeTooltip();
	openTooltip(_t, e);
});
$('.impl-price__item-info-close').click(function(){
	closeTooltip();
});

$('.prot-price__item-info-button').click(function(e){
	let _t = $(this).next();
	closeTooltip();
	openTooltip(_t, e);
});
$('.prot-price__item-info-close').click(function(){
	closeTooltip();
});

$('.impl-price__item-more-button').click(function(){
	let el = $(this).next();
	if (el.is(':visible'))
		$(this).removeClass('active');
	else
		$(this).addClass('active');
	el.slideToggle();
});

$('.themes__title').click(function(){
	$(this).toggleClass("active");
	$(this).siblings(".themes__list-wrapper").slideToggle();
});
